import React from 'react';
import classNames from 'classnames';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { FormatCurrency } from '@css-xp/ppc-common';
import './estimate.scss';

export type EstimateProps = {
  currency: string;
  price: number;
  isTotal?: boolean;
  hidePerUserText?: boolean;
  className?: string;
  loading?: boolean;
  style?: React.CSSProperties;
};

export const Estimate: React.FC<EstimateProps> = ({
  currency,
  price,
  isTotal = false,
  className,
  hidePerUserText = true,
  loading = false,
  ...restProps
}) => {
  return (
    <div data-testid="ppc-checkout-estimate" className={'ppc-checkout-estimate'}>
      {loading ? (
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="100px" height="20px" marginBottom={'0'} />
        </SkeletonLoaderWrapper>
      ) : (
        <h4
          className={classNames(
            {
              'line-item-estimate': !isTotal,
              'total-estimate': isTotal,
            },
            className
          )}
          {...restProps}
        >
          <FormatCurrency currency={currency} value={price} showCurrencyCode showCommas />
          {!hidePerUserText && ' / User'}
        </h4>
      )}
    </div>
  );
};
